module.exports = __webpack_public_path__ + "img/09977bb85b1095b388ff64baa98a87b6.5574fd93.jpg";